export enum CardType {
    DEFAULT = 'default',
    HUMAN_INSIGHT = 'performer',
    PERFORMANCE_INSIGHT = 'business',
}
